import { H2, H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';

import { TPreparedContentBlocks } from '~/src/features/aboutV2/helpers';

import * as ST from './styled';

interface IProps {
    stats: TPreparedContentBlocks[],
}

const Stats = ({ stats }: IProps) => {
    return (
        <ST.Stats as='section' indent={{ $mobile: [32], $desktop: [40] }} rounder={{ $radius: 32 }}>
            <ListContainer as='ul' $mobile={24} $desktop={32} $justifyContent='center'>
                {stats.map(({ id, title, desc }) => (
                    <ST.ListItem key={id}>
                        <H2 $smaller $withIndent={false} $color='TextSecondary'>{title}</H2>
                        <H4 as='div' $color='TextInfo' $smaller $withIndent={false} dangerouslySetInnerHTML={{ __html: desc }} />
                    </ST.ListItem>
                ))}
            </ListContainer>
        </ST.Stats>
    );
};

export default Stats;
